import { render, staticRenderFns } from "./Referate.vue?vue&type=template&id=5db04680"
import script from "./Referate.vue?vue&type=script&lang=js"
export * from "./Referate.vue?vue&type=script&lang=js"
import style0 from "@/assets/paap.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/assets/LAcordion.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports